import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

export function dateRangeValidator(fromControlName: string, toControlName: string): ValidatorFn {
  return (formGroup: AbstractControl): ValidationErrors | null => {
    const fromControl = formGroup.get(fromControlName);
    const toControl = formGroup.get(toControlName);

    if (!fromControl || !toControl) {
      return null;
    }

    const fromDate = fromControl.value;
    const toDate = toControl.value;

    if (!fromDate || !toDate) {
      return null;
    }

    const isValid = moment(fromDate).isSameOrBefore(toDate, 'day');

    if (!isValid) {
      fromControl.setErrors({ ...fromControl.errors, dateRange: true });
      toControl.setErrors({ ...toControl.errors, dateRange: true });
      return { dateRange: true };
    } else {
      clearDateRangeError(fromControl);
      clearDateRangeError(toControl);
      return null;
    }
  };
}

function clearDateRangeError(control: AbstractControl): void {
  if (control.errors && control.errors['dateRange']) {
    const errors = { ...control.errors };
    delete errors['dateRange'];
    control.setErrors(Object.keys(errors).length ? errors : null);
  }
}

export function getDateRangeErrorMessage(
  control: AbstractControl,
  controlLabel: string
): string | null {
  if (control.hasError('required')) {
    return `${controlLabel} is required`;
  }
  if (control.hasError('dateRange')) {
    return null;
  }
  return null;
}
